// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_TZZlL,.container_TZZlL *{box-sizing:border-box;-webkit-font-smoothing:antialiased;font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.container_TZZlL{border-radius:0;background:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.15)}.header_Tk7cS{display:flex}.closeButton_PxFLX{display:flex;align-items:center;justify-content:center;border-left:1px solid rgba(0,0,0,.15);width:60px;height:60px;cursor:pointer}.closeButton_PxFLX .closeIcon_IL9P\\+{width:14px;height:14px;color:#272525}", ""]);
// Exports
exports.locals = {
	"container": "container_TZZlL",
	"header": "header_Tk7cS",
	"closeButton": "closeButton_PxFLX",
	"closeIcon": "closeIcon_IL9P+"
};
module.exports = exports;
